import { z } from "zod/v4";

export const GetBillingPortalRequestBodySchema = z.object({
  stripeSubscriptionId: z.string().nullish(),
  stripeCustomerId: z.string().nullish(),
});

export type GetBillingPortalRequestBodyType = z.infer<
  typeof GetBillingPortalRequestBodySchema
>;

export const GetBillingPortalResponseBodySchema = z.object({
  url: z.string(),
});

export type GetBillingPortalResponseBodyType = z.infer<
  typeof GetBillingPortalResponseBodySchema
>;
